import { render, staticRenderFns } from "./modelTestStatistics.vue?vue&type=template&id=74369c70&scoped=true"
import script from "./modelTestStatistics.vue?vue&type=script&lang=js"
export * from "./modelTestStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74369c70",
  null
  
)

export default component.exports